import { render, staticRenderFns } from "./dotline.vue?vue&type=template&id=22d35790&scoped=true"
import script from "./dotline.vue?vue&type=script&lang=js"
export * from "./dotline.vue?vue&type=script&lang=js"
import style0 from "./dotline.vue?vue&type=style&index=0&id=22d35790&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d35790",
  null
  
)

export default component.exports